import { AdminReportsResponse, ReportLevel } from "../adminReportsApiSlice";
import { reportSubLevelName } from "../adminReportsUtil";
import { PromptTable } from "./PromptTable";
import { PromptUsageAndPerformanceByLevelRow } from "./adminPromptReportApiSlice";

export function PromptUsageAndPerformanceByLevelTable(props: {
	className: string;
	level: ReportLevel;
	data: AdminReportsResponse<PromptUsageAndPerformanceByLevelRow>;
	hideRows: boolean;
	setDistrictFilter: (districtId: number) => void;
	setSchoolFilter: (schoolId: number) => void;
}) {
	function handleNameClick(row: PromptUsageAndPerformanceByLevelRow) {
		if (props.level === ReportLevel.State) {
			props.setDistrictFilter(row.id);
		} else if (props.level === ReportLevel.District) {
			props.setSchoolFilter(row.id);
		}
	}

	return (
		<PromptTable
			className={props.className}
			level={props.level}
			data={props.data}
			hideRows={props.hideRows}
			dataKey="id"
			nameField="name"
			nameHeader={reportSubLevelName(props.level)}
			onNameClick={props.level !== ReportLevel.School ? handleNameClick : undefined}
			showTeacherColumn={props.level === ReportLevel.School}
			teacherField="teachers"
			showMostRecentColumn={true}
			mostRecentField="mostRecentSubmission"
		/>
	);
}
